import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { UmrahBadge } from 'entities/umrah/ui'
import { BadgeColor } from 'entities/umrah/ui/umrah-badge/umra-badge.tsx'

import { UmrahTour } from 'shared/api/umrah/tours'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList.ts'
import { UmrahClass, UmrahClassTypes } from 'shared/constants/umrah'
import { dateFormat, differenceDate } from 'shared/lib/dateFormat.ts'
import { ImageLazy } from 'shared/ui/image-lazy'
import { PriceDollar } from 'shared/ui/price-dollar'

import s from './styles.module.scss'

interface Props {
  priceText?: string
  tour?: UmrahTour | null
}

export const UmrahTourInfo = ({ priceText, tour }: Props) => {
  const { t } = useTranslation()

  const dateStart = tour?.schedule?.start_date
  const dateEnd = tour?.schedule?.end_date

  const days = differenceDate({
    dateStart,
    dateEnd,
    type: 'day',
  })

  const tourClass = UmrahClass[tour?.class_type as UmrahClassTypes]

  return (
    <div className={s.container}>
      <div className={s.header}>
        <p className={clsx('semi-bold-14', s.company)}>{tour?.agency?.name}</p>

        <UmrahBadge color={tourClass?.color as BadgeColor}>
          {t(tourClass?.title)}
        </UmrahBadge>
      </div>

      <div className={clsx('extra-bold-16', s.date)}>
        {t('umrah_block.dates', {
          start: dateFormat(dateStart, DATE_FORMAT_LIST.FULL_DATE_SHORT_YEAR),
          end: dateFormat(dateEnd, DATE_FORMAT_LIST.FULL_DATE_SHORT_YEAR),
          count: days,
        })}
      </div>

      <div className={s.infoList}>
        {tour?.elements?.map((item, index) => (
          <div
            key={index}
            className={s.infoItem}
          >
            {item?.icon && (
              <ImageLazy
                src={item?.icon}
                alt="icon"
                className={s.icon}
              />
            )}

            <span className={clsx('medium-12', s.title)}>{item?.name}</span>
          </div>
        ))}
      </div>
      <div className={s.divider} />

      <PriceDollar
        som={tour?.price}
        dollar={tour?.price_usd}
      />

      {priceText && (
        <p className={clsx('semi-bold-12', s.priceText)}>{priceText}</p>
      )}
    </div>
  )
}
